import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M12.667 13.167a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2Zm-2 1.5a2 2 0 0 1-2-2v-2c0-.278.056-.542.158-.782a.779.779 0 0 1-.022-.021L6.136 7.197a.754.754 0 0 1-.021-.022c-.24.102-.504.158-.782.158h-2a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2c0 .278-.056.542-.158.782a.779.779 0 0 1 .022.021l2.667 2.667a.74.74 0 0 1 .021.022c.24-.102.504-.158.782-.158h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2ZM5.333 5.833a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2Z';
const draw24px = 'M19 20.5a1.5 1.5 0 0 0 1.5-1.5v-3a1.5 1.5 0 0 0-1.5-1.5h-3a1.5 1.5 0 0 0-1.5 1.5v3a1.5 1.5 0 0 0 1.5 1.5h3ZM16 22a3 3 0 0 1-3-3v-3c0-.556.151-1.077.415-1.524l-3.891-3.891A2.985 2.985 0 0 1 8 11H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v3c0 .556-.151 1.077-.415 1.524l3.891 3.891A2.985 2.985 0 0 1 16 13h3a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3h-3ZM8 9.5A1.5 1.5 0 0 0 9.5 8V5A1.5 1.5 0 0 0 8 3.5H5A1.5 1.5 0 0 0 3.5 5v3A1.5 1.5 0 0 0 5 9.5h3Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const LinkSplineIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'linkSpline'));
LinkSplineIcon.displayName = 'LinkSplineIcon';
LinkSplineIcon.propTypes = Icon.propTypes;
LinkSplineIcon.renderIcon = props => /*#__PURE__*/React.createElement(LinkSplineIcon, props);
export default LinkSplineIcon;
//# sourceMappingURL=LinkSplineIcon.js.map